<template>
<div>
  <div class="hero">
    <Nav></Nav>
    <img src="../assets/hero-background-mobile.jpg" class="img hero-bg-img hide-desktop">
    <img src="../assets/hero-background-desktop.jpg" class="img hero-bg-img hide-mobile">
    <div class="hero-content">
      <div class="container test2">
      <div class="test">
        <img src="../assets/device.png" alt="" class="img wristband">
      </div>
      <div class="hero-content-left">
        <img src="../assets/relaxY-logo-text-blue.png" alt="" class="hero-logo img hide-desktop">
        <h3 class="hero-text">Bring real-time biofeedback into therapy.</h3>
        <a href="#how-it-works" style="margin-top: 40px;"> <OrangeButton></OrangeButton></a>
      </div>
     </div> 
  </div>
    
  </div>
 </div>       
</template>

<script>


import Nav from "@/components/Nav"
import OrangeButton from "@/components/OrangeButton"

export default {  
    components: {
      Nav,
      OrangeButton
    },
  name: 'Hero',
}
</script>


<style scoped>

.hero {
  height: 100%;
}

.hero-bg-img {
  height: 100vh;
  top: 0;
}

.hero-content {
  position: absolute;
  top: 12%;
  width: 100%;
}

.test2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 37px 0 37px;
}

.hero-content-left {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero-logo {
  margin-top: 75px;
  max-width: 300px;
}

.hero-text {
  display: flex;
  text-align: center;
  font-weight: 300;
}

.wristband {
  max-width: 400px;
}

@media screen and (min-width: 1220px) {

.wristband {
  max-width: 500px;

  display: flex;
    justify-content: center;

 }

.test2 {

  display: flex;
  flex-direction: row-reverse;
  margin-top: 5%;
  justify-content: space-between;

}

.hero-content-left {
  align-items:flex-start;
  width: 50%;
}

 .hero-content h3 {
   font-size: 60px;
   text-align: left;
   margin-bottom: 0;
   color: #91A4A8;
 }
 .test {
   width: 40%;
   display: flex;
  justify-content: center;
 }

}

</style>
